module.exports = __webpack_public_path__ + "fonts/YekanBakhFaNumThin.41a4531.ttf";